import React, { useMemo } from "react";
import { useAttendance } from "../../../hooks/attendance/AttendanceContext";
import EmployeeSelectSearch from "components/EmployeeSelectSearch/EmployeeSelectSearch";
import { useTranslation } from 'react-i18next';

/**
 * Filtro por empleados (selección múltiple) para supervisión de asistencia.
 */
const EmployeeFilter = () => {
	const { t } = useTranslation();
	const { filters } = useAttendance();

	const selectedEmployeeIds = filters.employeeIds
		? filters.employeeIds
				.split(",")
				.filter((id) => id)
				.map((id) => id.replace(/[\[\]]/g, "").trim())
		: [];

	const fetchOptions = useMemo(() => ({ enabled: true }), []);

	const handleChange = (ids) => {
		filters.handleEmployeeChange(ids.join(","));
	};

	return (
		<EmployeeSelectSearch
			multiple
			value={selectedEmployeeIds}
			onChange={handleChange}
			fetchOptions={fetchOptions}
			allLabel={t('common.allEmployees')}
		/>
	);
};

export default EmployeeFilter;
